import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    deleteButtonLabel: 'Delete',
    deleteConfirmationMessage:
      'Are you sure you want to delete this care partner?',
  },
})
